/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/lib/globalize"/>

// Purpose of this module is not to operate on window object explicitly in modules to make it easier to mock or substitute in future

export const Globalize = (this as any).globals.Globalize;